import { render } from "./GDPR.vue?vue&type=template&id=11a50e8e"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__